




































































import MusicAudioViewModel from "@models/music/musicAudioViewModel";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class AddAudioModalComponent extends Vue {  
  @Prop({type: Object}) audio: MusicAudioViewModel;
  @Prop({default: false}) show: boolean;  
  currentAudio: MusicAudioViewModel = null;
  isShowModal: boolean = false;
  create() {
    
    }
  @Watch('audio')
  onChangeAudio(newValue: MusicAudioViewModel) {
    this.currentAudio = this.audio == null ? null : this.audio.clone();
    this.isShowModal = true;
  }
  @Watch('show')
  showUpdate(newValue: boolean) {
    this.isShowModal = newValue;
    if(newValue) {
      this.currentAudio = this.audio == null ? null : this.audio.clone();
    }
  }
  removeAudio() {
    this.currentAudio.audioFile = null;
    this.currentAudio.base64File = null;
    this.currentAudio.audioUrl = null;
  }
  emit() {
    this.$emit('change', this.currentAudio);
    this.isShowModal = false;
  }
  cancelAddAudio() {
    this.isShowModal = false;
    this.currentAudio = null;
    // this.emit();
    this.$emit('close');
  }
  onOkAudioModal() {
    const isValid = (this.$refs.audioValidator as any).isValid();
    if (!isValid) return;
    this.emit();
    this.currentAudio = null;
  }
}
